import { BigNumber } from '@ethersproject/bignumber'
import { hexStripZeros } from '@ethersproject/bytes'
import { Web3Provider } from '@ethersproject/providers'
import { CHAIN_INFO } from 'constants/chainInfo'
import { SupportedChainId } from 'constants/chains'
import { INFURA_NETWORK_URLS } from 'constants/infura'

interface SwitchNetworkArguments {
  library: Web3Provider
  chainId: SupportedChainId
}

function getRpcUrls(chainId: SupportedChainId): [string] {
  switch (chainId) {
    //case SupportedChainId.RINKEBY:
    //case SupportedChainId.ROPSTEN:
    //case SupportedChainId.KOVAN:
    //case SupportedChainId.GOERLI:
    case SupportedChainId.MAINNET:
    case SupportedChainId.BSC:
      return [INFURA_NETWORK_URLS[chainId]]
    //case SupportedChainId.OPTIMISM:
    //  return ['https://mainnet.optimism.io']
    //case SupportedChainId.OPTIMISTIC_KOVAN:
    //  return ['https://kovan.optimism.io']
    //case SupportedChainId.ARBITRUM_ONE:
    //  return ['https://arb1.arbitrum.io/rpc']
    //case SupportedChainId.ARBITRUM_RINKEBY:
    //  return ['https://rinkeby.arbitrum.io/rpc']
    case SupportedChainId.POLYGON:
      return ['https://polygon-rpc.com/']
    //case SupportedChainId.POLYGON_MUMBAI:
    //  return ['https://rpc-endpoints.superfluid.dev/mumbai']
    default:
  }
  // Our API-keyed URLs will fail security checks when used with external wallets.
  throw new Error('RPC URLs must use public endpoints')
}

// provider.request returns Promise<any>, but wallet_switchEthereumChain must return null or throw
// see https://github.com/rekmarks/EIPs/blob/3326-create/EIPS/eip-3326.md for more info on wallet_switchEthereumChain
export async function switchToNetwork({ library, chainId }: SwitchNetworkArguments): Promise<null | void> {
  if (!library?.provider?.request) {
    return
  }
  const formattedChainId = hexStripZeros(BigNumber.from(chainId).toHexString())
  try {
    await library.provider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: formattedChainId }],
    })
  } catch (error) {
    // 4902 is the error code for attempting to switch to an unrecognized chainId
    if (error.code === 4902) {
      const info = CHAIN_INFO[chainId]

      await library.provider.request({
        method: 'wallet_addEthereumChain',
        params: [
          {
            chainId: formattedChainId,
            chainName: info.label,
            rpcUrls: getRpcUrls(chainId),
            nativeCurrency: info.nativeCurrency,
            blockExplorerUrls: [info.explorer],
          },
        ],
      })
      // metamask (only known implementer) automatically switches after a network is added
      // the second call is done here because that behavior is not a part of the spec and cannot be relied upon in the future
      // metamask's behavior when switching to the current network is just to return null (a no-op)
      try {
        await library.provider.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: formattedChainId }],
        })
      } catch (error) {
        console.debug('Added network but could not switch chains', error)
      }
    } else {
      throw error
    }
  }
}
